// src/pages/HomePage.js
import React from 'react';
import { Link } from 'react-router-dom';
import TodayAvailabilityGrid from '../components/facilities/TodayAvailabilityGrid';

const HomePage = () => {
  return (
    <div className="homepage-content">
      <h1>World Tower Residence</h1>

      <section className="facility-availability" style={{ marginTop: '40px', marginBottom: '40px' }}>
        <TodayAvailabilityGrid />
      </section>

      <section className="quick-links">
        <h2>クイックアクセス</h2>
        <ul>
          <li><Link to="/facilities/bar-lounge">バーラウンジのメニューを見る</Link></li>
          {/* 将来的に追加するリンクの例
          <li><Link to="/announcements">最新のお知らせ</Link></li>
          <li><Link to="/facilities/gym">ジムの利用案内</Link></li>
          <li><Link to="/reservations">共用施設の予約状況</Link></li>
          */}
        </ul>
      </section>

      <p style={{ marginTop: '50px', textAlign: 'center', color: '#888', fontSize: '0.9em' }}>
        このサイトは現在一部コンテンツを公開中です。今後、順次情報を拡充していく予定です。
      </p>
    </div>
  );
};

export default HomePage;